import { render, staticRenderFns } from "./conversation-summary-open-contact-requests.vue?vue&type=template&id=0671969b&scoped=true&"
import script from "./conversation-summary-open-contact-requests.vue?vue&type=script&lang=js&"
export * from "./conversation-summary-open-contact-requests.vue?vue&type=script&lang=js&"
import style0 from "./conversation-summary-open-contact-requests.vue?vue&type=style&index=0&id=0671969b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0671969b",
  null
  
)

export default component.exports